export default "__VITE_ASSET__01IKtq3v__"